// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 📱 MOBILE TOP BAR STYLES */
.mobile-top-bar {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    padding: 14px 20px;   /* padding simétrico: hamburger visible a la izquierda */
    background-color: #000;
    z-index: 1050;
    border-bottom: 1px solid rgba(255, 255, 255, 0.05);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

/* Wallet Balance Items */
/* Wallet Balance Items */
.wallet-balance-icon {
    font-size: 1.7rem; /* Increased from 1.5rem */
    color: white;      /* Changed from #8c8c8c to white */
}

.wallet-balance-text {
    font-size: 1.3rem; /* Increased from 1.1rem */
    color: white;
    white-space: nowrap;
}

.mobile-nav-icons {
    flex: 1;
    overflow-x: auto;
    overflow-y: hidden;
    white-space: nowrap;
    -webkit-overflow-scrolling: touch;
    margin-left: 20px;
    /* Hide scrollbar */
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none;  /* IE 10+ */
    justify-content: flex-end; /* Align right but scrollable if needed */
}

.mobile-nav-icons::-webkit-scrollbar { 
    display: none; /* Chrome/Safari */
}

.mobile-nav-item {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 45px;
    height: 45px;
    border-radius: 10px;
    color: #8c8c8c;
    transition: all 0.2s ease;
    flex-shrink: 0;
    text-decoration: none; /* Fix wallet balance underline */
}

.mobile-nav-item i {
    font-size: 1.5rem;
}

.mobile-nav-item:hover {
    background-color: rgba(255, 255, 255, 0.05);
    color: white;
}

.mobile-nav-item.active {
    background: linear-gradient(135deg, #d38302 0%, #aa6a02 100%);
    color: white;
    box-shadow: 0 4px 10px rgba(240, 149, 2, 0.3);
}

.mobile-nav-item img {
    filter: brightness(0.6);
    transition: all 0.2s ease;
}

.mobile-nav-item.active img {
    filter: brightness(0) invert(1);
}

/* Spacer for iOS safe area if needed */
/* Plus Button Mobile */
.plus-btn-mobile {
    width: 40.625px;
    height: 40.625px;
    background-color: #f09502;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #000000;
    font-size: 1.4rem;
    box-shadow: 0 4px 10px rgba(240, 149, 2, 0.3);
    flex-shrink: 0;
}

.refresh-btn-mobile {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 28.4px;
    height: 26.2px;
    cursor: pointer;
    flex-shrink: 0;
}

.refresh-btn-mobile i {
    color: #FF9600 !important;
    font-size: 26px !important;
    transition: transform 0.3s;
}

@media (max-width: 768px) {
    .menu-movil-container {
        pointer-events: auto; /* Ensure updated container allows clicks */
    }
}

/* User Avatar Circle */
.user-avatar-circle {
    width: 32px;
    height: 32px;
    background-color: #a87ffb; /* Purple like screenshot */
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-weight: 600;
    font-size: 1rem;
}

/* 🔔 NOTIFICATION BELL OVERRIDES FOR MOBILE/DARK THEME */
::ng-deep .mobile-nav-item app-notification-bell .notification-bell i, 
::ng-deep .drawer-item app-notification-bell .notification-bell i {
    color: white !important; /* Force icon white */
}

/* Unset the filter blob effect */
.mobile-nav-item app-notification-bell, 
.drawer-item app-notification-bell {
    filter: none !important;
}

/* Fix Dropdown position in mobile top bar */
::ng-deep .mobile-nav-item app-notification-bell .notification-dropdown {
    top: 50px !important;
    right: -10px !important;
    width: 300px !important;
    max-width: 90vw !important;
    box-shadow: 0 4px 15px rgba(0,0,0,0.5) !important;
}

/* 📂 SIDEBAR STYLES */
.mobile-sidebar {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    width: 85%;
    max-width: 300px;
    background-color: #000;
    z-index: 1060; /* Higher than topbar */
    padding: 34px 24px;
    transform: translateX(-100%);
    transition: transform 0.3s cubic-bezier(0.4, 0.0, 0.2, 1);
    box-shadow: 4px 0 15px rgba(0, 0, 0, 0.5);
    overflow-y: auto;
    display: flex;
    flex-direction: column;
}

.mobile-sidebar.open {
    transform: translateX(0);
}

.balance-section {
    margin-bottom: 28px;
}

.balance-amount-row {
    margin-top: 16px;
}

.balance-label {
    color: #FFF;
    font-family: Montserrat, sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-self: stretch;
    margin: 0;
    white-space: nowrap;
}

.balance-amount {
    color: #FFF;
    text-align: left;
    font-family: Montserrat, sans-serif;
    font-size: 22px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    white-space: nowrap;
    width: auto;
    height: auto;
}

.sidebar-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    align-self: stretch;
    margin-bottom: 28px;
}

/* Fila propia del hamburguesa, arriba del logo (como en Figma: el hamburguesa
   va en la franja superior, no a la altura del logo). */
.sidebar-topbar {
    display: flex;
    align-items: center;
    margin-bottom: 18px;
}

.sidebar-hamburger {
    background: transparent;
    border: none;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    flex-shrink: 0;
}

.sidebar-logo {
    width: 184px;
    height: 57px;
    object-fit: contain;
    mix-blend-mode: lighten;
}

.close-icon {
    width: 24px;
    height: 24px;
    cursor: pointer;
    flex-shrink: 0;
}

/* NAVIGATION LINKS */
.sidebar-link {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 8px 10px;   /* más compacto que antes (10px) → botones naranjas de altura correcta */
    align-self: stretch;
    text-decoration: none;
    color: white;
    border-radius: 8px;
    cursor: pointer;
}

.sidebar-link span {
    font-family: Montserrat, sans-serif;
    font-size: 16px;     /* reducido de 24px → tamaño consistente con el resto de la app */
    font-style: normal;
    font-weight: 400;
    line-height: 1.3;
    display: flex;
    align-items: center;
    white-space: nowrap;
    overflow: visible;
    flex-shrink: 0;
}

.sidebar-icon-container {
    width: 24px;
    height: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
}

.sidebar-icon-container img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    filter: brightness(0) invert(1);
    transition: filter 0.2s;
}

.sidebar-icon-container.active img,
.sidebar-icon-container.active svg {
    filter: brightness(0) invert(1) !important;
}

.sidebar-link.active-link {
    background: linear-gradient(90deg, #C49953 0%, #FF9600 100%) !important;
    color: white !important;
}

.sidebar-link.active-link .sidebar-icon-container img,
.sidebar-link.active-link .sidebar-icon-container svg {
    filter: brightness(0) invert(1) !important;
}

.sidebar-link-group {
    display: flex;
    flex-direction: column;
}

.transition-transform {
    transition: transform 0.3s ease;
}
.rotate {
    transform: rotate(180deg);
}

.sidebar-submenu {
    display: flex;
    flex-direction: column;
    padding-left: 50px;
    gap: 15px;
    margin-top: 5px;
    margin-bottom: 15px;
}

.sidebar-submenu a {
    text-decoration: none;
    color: white;
    font-size: 1rem;
    transition: color 0.2s;
}

.sidebar-submenu a:hover, .sidebar-submenu a.active-sub {
    color: #f09502;
}

/* OVERLAY */
.drawer-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.6);
    z-index: 1055; /* Just below sidebar */
    backdrop-filter: blur(2px);
}`, "",{"version":3,"sources":["webpack://./src/app/components/menu-movil/menu-movil.component.css"],"names":[],"mappings":"AAAA,6BAA6B;AAC7B;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,kBAAkB,IAAI,wDAAwD;IAC9E,sBAAsB;IACtB,aAAa;IACb,kDAAkD;IAClD,yCAAyC;AAC7C;;AAEA,yBAAyB;AACzB,yBAAyB;AACzB;IACI,iBAAiB,EAAE,0BAA0B;IAC7C,YAAY,OAAO,kCAAkC;AACzD;;AAEA;IACI,iBAAiB,EAAE,0BAA0B;IAC7C,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,OAAO;IACP,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,iCAAiC;IACjC,iBAAiB;IACjB,mBAAmB;IACnB,qBAAqB,EAAE,YAAY;IACnC,wBAAwB,GAAG,WAAW;IACtC,yBAAyB,EAAE,yCAAyC;AACxE;;AAEA;IACI,aAAa,EAAE,kBAAkB;AACrC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,cAAc;IACd,yBAAyB;IACzB,cAAc;IACd,qBAAqB,EAAE,iCAAiC;AAC5D;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,2CAA2C;IAC3C,YAAY;AAChB;;AAEA;IACI,6DAA6D;IAC7D,YAAY;IACZ,6CAA6C;AACjD;;AAEA;IACI,uBAAuB;IACvB,yBAAyB;AAC7B;;AAEA;IACI,+BAA+B;AACnC;;AAEA,uCAAuC;AACvC,uBAAuB;AACvB;IACI,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,iBAAiB;IACjB,6CAA6C;IAC7C,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,cAAc;IACd,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;IAC1B,0BAA0B;AAC9B;;AAEA;IACI;QACI,oBAAoB,EAAE,2CAA2C;IACrE;AACJ;;AAEA,uBAAuB;AACvB;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB,EAAE,2BAA2B;IACtD,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,gBAAgB;IAChB,eAAe;AACnB;;AAEA,yDAAyD;AACzD;;IAEI,uBAAuB,EAAE,qBAAqB;AAClD;;AAEA,iCAAiC;AACjC;;IAEI,uBAAuB;AAC3B;;AAEA,4CAA4C;AAC5C;IACI,oBAAoB;IACpB,uBAAuB;IACvB,uBAAuB;IACvB,0BAA0B;IAC1B,iDAAiD;AACrD;;AAEA,sBAAsB;AACtB;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,sBAAsB;IACtB,aAAa,EAAE,uBAAuB;IACtC,kBAAkB;IAClB,4BAA4B;IAC5B,yDAAyD;IACzD,yCAAyC;IACzC,gBAAgB;IAChB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,mCAAmC;IACnC,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,mCAAmC;IACnC,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;wDACwD;AACxD;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,cAAc;AAClB;;AAEA,qBAAqB;AACrB;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,iBAAiB,IAAI,wEAAwE;IAC7F,mBAAmB;IACnB,qBAAqB;IACrB,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,mCAAmC;IACnC,eAAe,MAAM,iEAAiE;IACtF,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,+BAA+B;IAC/B,uBAAuB;AAC3B;;AAEA;;IAEI,0CAA0C;AAC9C;;AAEA;IACI,uEAAuE;IACvE,uBAAuB;AAC3B;;AAEA;;IAEI,0CAA0C;AAC9C;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,+BAA+B;AACnC;AACA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,SAAS;IACT,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,cAAc;AAClB;;AAEA,YAAY;AACZ;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,oCAAoC;IACpC,aAAa,EAAE,uBAAuB;IACtC,0BAA0B;AAC9B","sourcesContent":["/* 📱 MOBILE TOP BAR STYLES */\n.mobile-top-bar {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    padding: 14px 20px;   /* padding simétrico: hamburger visible a la izquierda */\n    background-color: #000;\n    z-index: 1050;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.05);\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n}\n\n/* Wallet Balance Items */\n/* Wallet Balance Items */\n.wallet-balance-icon {\n    font-size: 1.7rem; /* Increased from 1.5rem */\n    color: white;      /* Changed from #8c8c8c to white */\n}\n\n.wallet-balance-text {\n    font-size: 1.3rem; /* Increased from 1.1rem */\n    color: white;\n    white-space: nowrap;\n}\n\n.mobile-nav-icons {\n    flex: 1;\n    overflow-x: auto;\n    overflow-y: hidden;\n    white-space: nowrap;\n    -webkit-overflow-scrolling: touch;\n    margin-left: 20px;\n    /* Hide scrollbar */\n    scrollbar-width: none; /* Firefox */\n    -ms-overflow-style: none;  /* IE 10+ */\n    justify-content: flex-end; /* Align right but scrollable if needed */\n}\n\n.mobile-nav-icons::-webkit-scrollbar { \n    display: none; /* Chrome/Safari */\n}\n\n.mobile-nav-item {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 45px;\n    height: 45px;\n    border-radius: 10px;\n    color: #8c8c8c;\n    transition: all 0.2s ease;\n    flex-shrink: 0;\n    text-decoration: none; /* Fix wallet balance underline */\n}\n\n.mobile-nav-item i {\n    font-size: 1.5rem;\n}\n\n.mobile-nav-item:hover {\n    background-color: rgba(255, 255, 255, 0.05);\n    color: white;\n}\n\n.mobile-nav-item.active {\n    background: linear-gradient(135deg, #d38302 0%, #aa6a02 100%);\n    color: white;\n    box-shadow: 0 4px 10px rgba(240, 149, 2, 0.3);\n}\n\n.mobile-nav-item img {\n    filter: brightness(0.6);\n    transition: all 0.2s ease;\n}\n\n.mobile-nav-item.active img {\n    filter: brightness(0) invert(1);\n}\n\n/* Spacer for iOS safe area if needed */\n/* Plus Button Mobile */\n.plus-btn-mobile {\n    width: 40.625px;\n    height: 40.625px;\n    background-color: #f09502;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: #000000;\n    font-size: 1.4rem;\n    box-shadow: 0 4px 10px rgba(240, 149, 2, 0.3);\n    flex-shrink: 0;\n}\n\n.refresh-btn-mobile {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 28.4px;\n    height: 26.2px;\n    cursor: pointer;\n    flex-shrink: 0;\n}\n\n.refresh-btn-mobile i {\n    color: #FF9600 !important;\n    font-size: 26px !important;\n    transition: transform 0.3s;\n}\n\n@media (max-width: 768px) {\n    .menu-movil-container {\n        pointer-events: auto; /* Ensure updated container allows clicks */\n    }\n}\n\n/* User Avatar Circle */\n.user-avatar-circle {\n    width: 32px;\n    height: 32px;\n    background-color: #a87ffb; /* Purple like screenshot */\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: white;\n    font-weight: 600;\n    font-size: 1rem;\n}\n\n/* 🔔 NOTIFICATION BELL OVERRIDES FOR MOBILE/DARK THEME */\n::ng-deep .mobile-nav-item app-notification-bell .notification-bell i, \n::ng-deep .drawer-item app-notification-bell .notification-bell i {\n    color: white !important; /* Force icon white */\n}\n\n/* Unset the filter blob effect */\n.mobile-nav-item app-notification-bell, \n.drawer-item app-notification-bell {\n    filter: none !important;\n}\n\n/* Fix Dropdown position in mobile top bar */\n::ng-deep .mobile-nav-item app-notification-bell .notification-dropdown {\n    top: 50px !important;\n    right: -10px !important;\n    width: 300px !important;\n    max-width: 90vw !important;\n    box-shadow: 0 4px 15px rgba(0,0,0,0.5) !important;\n}\n\n/* 📂 SIDEBAR STYLES */\n.mobile-sidebar {\n    position: fixed;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    width: 85%;\n    max-width: 300px;\n    background-color: #000;\n    z-index: 1060; /* Higher than topbar */\n    padding: 34px 24px;\n    transform: translateX(-100%);\n    transition: transform 0.3s cubic-bezier(0.4, 0.0, 0.2, 1);\n    box-shadow: 4px 0 15px rgba(0, 0, 0, 0.5);\n    overflow-y: auto;\n    display: flex;\n    flex-direction: column;\n}\n\n.mobile-sidebar.open {\n    transform: translateX(0);\n}\n\n.balance-section {\n    margin-bottom: 28px;\n}\n\n.balance-amount-row {\n    margin-top: 16px;\n}\n\n.balance-label {\n    color: #FFF;\n    font-family: Montserrat, sans-serif;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-self: stretch;\n    margin: 0;\n    white-space: nowrap;\n}\n\n.balance-amount {\n    color: #FFF;\n    text-align: left;\n    font-family: Montserrat, sans-serif;\n    font-size: 22px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n    white-space: nowrap;\n    width: auto;\n    height: auto;\n}\n\n.sidebar-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 16px;\n    align-self: stretch;\n    margin-bottom: 28px;\n}\n\n/* Fila propia del hamburguesa, arriba del logo (como en Figma: el hamburguesa\n   va en la franja superior, no a la altura del logo). */\n.sidebar-topbar {\n    display: flex;\n    align-items: center;\n    margin-bottom: 18px;\n}\n\n.sidebar-hamburger {\n    background: transparent;\n    border: none;\n    padding: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    flex-shrink: 0;\n}\n\n.sidebar-logo {\n    width: 184px;\n    height: 57px;\n    object-fit: contain;\n    mix-blend-mode: lighten;\n}\n\n.close-icon {\n    width: 24px;\n    height: 24px;\n    cursor: pointer;\n    flex-shrink: 0;\n}\n\n/* NAVIGATION LINKS */\n.sidebar-link {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    padding: 8px 10px;   /* más compacto que antes (10px) → botones naranjas de altura correcta */\n    align-self: stretch;\n    text-decoration: none;\n    color: white;\n    border-radius: 8px;\n    cursor: pointer;\n}\n\n.sidebar-link span {\n    font-family: Montserrat, sans-serif;\n    font-size: 16px;     /* reducido de 24px → tamaño consistente con el resto de la app */\n    font-style: normal;\n    font-weight: 400;\n    line-height: 1.3;\n    display: flex;\n    align-items: center;\n    white-space: nowrap;\n    overflow: visible;\n    flex-shrink: 0;\n}\n\n.sidebar-icon-container {\n    width: 24px;\n    height: 24px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-shrink: 0;\n}\n\n.sidebar-icon-container img {\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n    filter: brightness(0) invert(1);\n    transition: filter 0.2s;\n}\n\n.sidebar-icon-container.active img,\n.sidebar-icon-container.active svg {\n    filter: brightness(0) invert(1) !important;\n}\n\n.sidebar-link.active-link {\n    background: linear-gradient(90deg, #C49953 0%, #FF9600 100%) !important;\n    color: white !important;\n}\n\n.sidebar-link.active-link .sidebar-icon-container img,\n.sidebar-link.active-link .sidebar-icon-container svg {\n    filter: brightness(0) invert(1) !important;\n}\n\n.sidebar-link-group {\n    display: flex;\n    flex-direction: column;\n}\n\n.transition-transform {\n    transition: transform 0.3s ease;\n}\n.rotate {\n    transform: rotate(180deg);\n}\n\n.sidebar-submenu {\n    display: flex;\n    flex-direction: column;\n    padding-left: 50px;\n    gap: 15px;\n    margin-top: 5px;\n    margin-bottom: 15px;\n}\n\n.sidebar-submenu a {\n    text-decoration: none;\n    color: white;\n    font-size: 1rem;\n    transition: color 0.2s;\n}\n\n.sidebar-submenu a:hover, .sidebar-submenu a.active-sub {\n    color: #f09502;\n}\n\n/* OVERLAY */\n.drawer-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(0, 0, 0, 0.6);\n    z-index: 1055; /* Just below sidebar */\n    backdrop-filter: blur(2px);\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
